<template>
  <div class="cdjj-wrapper" v-loading="loading">
    <div v-if="isShow">
      <div class="cdjj-header">
        <h2>教学计划填报</h2>
        <div class="btn">
          <div class="ipt">
            <el-select v-model="tableIpt.isExist" placeholder="请选择状态" clearable>
              <el-option label="全部" value="-1"></el-option>
              <el-option label="未填报" value="0"></el-option>
              <el-option label="已填报" value="1"></el-option>
            </el-select>
            <el-input v-model="tableIpt.trainName" @keyup.enter.native="searchList()" placeholder="请输入教学计划名称"></el-input>
          </div>
          <el-button plain @click="searchList()" style="margin-right:10px;">查 询</el-button>
        </div>
      </div>
      <div class="cdjj-table" :style="'padding-bottom:'+(tableData.length?'0':'16')+'px'">
        <el-table :data="tableData" style="width: 100%" :height="tableData.length?windowHeight-215:windowHeight-175" :header-cell-style="headerCellStyle" class="collegeTable" :cell-style="cellStyle" :empty-text="empty" @selection-change="handleSelectionChange">
          <el-table-column prop="trainName" label="教学计划名称">
            <template slot-scope="scope">
              <span>{{ scope.row.trainName? scope.row.trainName : '——'}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="isExist" label="状态">
            <template slot-scope="scope">
              <span>{{scope.row.isExist==0?"未填报":scope.row.isExist==1?"已填报":""}}</span>
            </template>
            </el-table-column>
          <el-table-column  label="操作">
            <template slot-scope="scope">
              <el-button @click.native.prevent="FillInPlan(scope.row)" round size="small">填报</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <Pagination
        :currentpage="pageTotal.currentPage"
        :limit="pageTotal.pageSize"
        :total="pageTotal.total"
        layout="sizes, prev, pager, next, jumper"
        @handleCurrentChange="handleCurrentChange"
        @handleSizeChange="handleSizeChange"
        :small="true"
        v-if="tableData.length"
      ></Pagination>
    </div>
    <OpeningInformation v-if="!isShow" :planData="planData" @switchShow="change($event)"></OpeningInformation>
    <div>

    </div>
  </div>
</template>
<script>
    import Pagination from "../../../paginator/paginator";
    import openingInformation from "./openingInformation";
    import axios from 'axios';
    import * as api from "../../../../api/educationalApi.js"
    export default {
        components: {
            Pagination,
            OpeningInformation:openingInformation
        },
        data() {
            return {
                isShow:true,
                tableIpt: {
                    isExist: "-1",
                    trainName: ''
                },
                tableData: [],
                windowHeight: window.innerHeight,
                height: window.innerHeight - 215 + "px", // 表格高度根据窗口高度来决定
                empty: '暂无数据',
                fileList: [],
                fileName: '',
                file: '',
                flag: true,
                loading: true,
                auth: {
                    save: false,
                    delete: false,
                    import: false
                },
                isExist:[],
                // "isExist"; 0 未填报 1 已填报  -1 全部
                teachingClass: '',
                flagAdd: 1,
                flagEdit: 1,
                multipleSelection: [],
                showDialog: false,
                success: '',
                pageTotal: {
                    currentPage: 1,
                    pageSize: 10,
                    total: 0,
                },
                planData:{}
            }
        },
        created() {
            this.getTrainPlanList();
        },
        methods: {
            // 获取教学计划列表
            getTrainPlanList(){
                let deptId = sessionStorage.getItem("deptId");
                let param = {
                    trainName:this.tableIpt.trainName,
                    isExist:this.tableIpt.isExist,
                    deptId:deptId,
                    pageNum:this.pageTotal.currentPage,
                    pageSize:this.pageTotal.pageSize
                };
                api.getTrainPlan(param).then(res=>{
                    this.loading = false;
                    if(res.code == 0){
                        let listArr = res.data;
                        this.tableData = listArr.list;
                        this.pageTotal.total = listArr.total;
                    }else{
                      this.$messageError(res.msg)
                    }
                }).catch(error => {
                    console.log(error)
                })
            },
            // 查询教学计划列表
            searchList() {
                this.loading = true;
                this.getTrainPlanList();
            },
            // 表格头部样式
            headerCellStyle({
                                row,
                                column,
                                rowIndex,
                                columnIndex
                            }) {
                if(rowIndex === 0 && columnIndex == 2) {
                    return "background:rgba(83,151,247,0.1);color:#999999; text-align:left !important; padding-left:20px !important;";
                } else if(rowIndex === 0 && columnIndex == 3) {
                    return "background:rgba(83,151,247,0.1);color:#999999; text-align:left !important; padding-left:20px !important;";
                } else {
                    return "background:rgba(83,151,247,0.1);color:#999999;";
                }
            },
            cellStyle(row, column, rowIndex, columnIndex) {
                if(row.columnIndex === 2 || row.columnIndex === 3) {
                    return "text-align:left !important;padding-left:20px !important;";
                }
            },
            handleCurrentChange(val) {//分页
              this.loading = true;
              this.pageTotal.currentPage = val;
              this.getTrainPlanList()
            },
            handleSizeChange(val){//分页
              this.loading = true;
              this.pageTotal.pageSize = val;
              this.pageTotal.currentPage = 1;
              this.getTrainPlanList()
            },
            handleSelectionChange(val) {
                this.multipleSelection = val;
            },
            //填报
            FillInPlan(row){
                this.isShow = !this.isShow;
                this.planData = row

            },
            change(data) {
               this.isShow=true;
               this.getTrainPlanList();
            }

        }
    }
</script>

<style lang="scss" scoped>
  .cdjj-wrapper {
    padding: 0 16px;
    background: #fff;
    margin: 16px 16px 0;
    border-radius: 4px;
    .cdjj-header {
      height: 48px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      border-bottom: 1px solid #5397f7;
      h2 {
        border-left: 2px solid #5397f7;
        color: #5397f7;
        font-size: 14px;
        padding-left: 4px;
        line-height: 10px;
      }
      .btn {
        display: flex;
        align-items: center;
        .el-button {
          min-width: 72px;
          padding: 7px 11px;
          border-color: #5397F7;
          color: #5397F7;
          font-size: 12px;
          &:hover {
            background: #5397F7;
            color: #fff;
          }
        }
        .class-btn {
          padding: 8px 15px;
        }
        .el-select {
          width: 160px;
          margin-right: 10px;
          /deep/ .el-input__inner {
            height: 30px;
            line-height: 30px;
          }
          /deep/ .el-input__icon {
            line-height: 30px;
          }
        }
        .el-input {
          width: 220px;
          margin-right: 10px;
          /deep/ .el-input__inner {
            height: 30px;
            line-height: 30px;
          }
          /deep/ .el-input__suffix {
            right: 0;
          }
          /deep/ .el-input__icon {
            width: 40px;
            line-height: 30px;
            color: #fff;
            background: #5397f7;
            border-radius: 0px 4px 4px 0px;
          }
        }
      }
    }
    .cdjj-table {
      margin-top: 16px;
      .collegeTable {
        border: 1px solid #ebebeb;
        border-radius: 4px;
        border-bottom: 0;
      }
      /deep/ .el-table__empty-text {
        display: block;
        width: 200px;
        height: 200px;
        padding-top: 190px;
        color: #909399;
        box-sizing: border-box;
        background: url('../../../../../static/images/wujieguo.png') no-repeat;
      }
    }
    /deep/ .el-dialog__header {
      background: #edf4ff;
      border-radius: 8px 8px 0 0;
      height: 18px;
      &:before {
        width: 2px;
        height: 10px;
        background: rgba(83, 151, 247, 1);
        opacity: 1;
        border-radius: 4px;
      }
    }
    /deep/ .el-dialog__title {
      display: block;
      font-size: 14px;
      color: #5397f7;
      border-left: 2px solid #5397f7;
      padding-left: 5px;
      line-height: 10px;
    }
    /deep/ .el-dialog__footer {
      .el-button {
        width: 79px;
        height: 32px;
        line-height: 32px;
        padding: 0;
      }
    }
    .failMsg {
      color: #F00000;
      text-align: center;
      a {
        cursor: pointer;
        color: #5397F7;
      }
    }
    .upload-content {
      padding: 90px;
      display: flex;
      justify-content: space-between;
      .el-input {
        width: 240px;
        margin-bottom: 16px;
      }
      .left {
        position: relative;
        p {
          font-size: 12px;
          color: #999999;
          margin-bottom: 6px;
          i {
            color: #E34646;
          }
          a {
            cursor: pointer;
            color: #5397F7;
            &:hover {
              text-decoration: underline;
            }
          }
        }
        span {
          position: absolute;
          width: 64px;
          height: 34px;
          line-height: 34px;
          text-align: center;
          border-radius: 0px 4px 4px 0px;
          right: 0;
          top: 0;
          color: #FFFFFF;
        }
        .off {
          background: rgba(226, 226, 226, 1);
        }
        .on {
          cursor: pointer;
          background: #5397F7
        }
      }
      .right {
        width: 88px;
        height: 88px;
        text-align: center;
        background: rgba(255, 255, 255, 1);
        border: 1px solid rgba(226, 226, 226, 1);
        border-radius: 4px;
        img {
          display: inline-block;
          width: 32px;
          height: 32px;
          margin-top: 16px;
          margin-bottom: 4px;
        }
        p {
          color: #999999;
        }
        .upload-demo {
          width: 100%;
          height: 100%;
        }
      }
    }
    .tishi {
      position: absolute;
      top: 2px;
      right: -24px;
    }
    /deep/ .el-button--small,
    .el-button--small.is-round {
      padding: 5px 15px;
      color: #5397F7;
    }
    .classDialog {
      /deep/ .el-dialog__body {
        padding: 30px 56px;
      }
    }
    /deep/ .el-table th>.cell{
      text-align: center;
    }
    /deep/ .el-table .cell{
      text-align: center;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/views/educationalAdmin/educationalAdminMenu/teacherPlan.vue